import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InsaCronService, LocalizeService } from "../../../../../insa-services";
import { ReportJobDetails } from "../../../../../insa-models";
import { SharedMethodsModule } from "../../../../../insa-custom-scripts";

import { ChronosJobListColumnDef, ChronosReportListColumnDef } from '../../../';

import { customGroupHeader } from '../../../../../insa-custom-scripts'
//import { filter } from "core-js/fn/array";
//import { equal } from "assert";



@Component({
    selector: "edit-report-details",
    template: require("./edit-report-details.component.html")
})

export class EditReportDetailComponent implements OnInit {
    @Input() editReportOptionsForm: FormGroup;
    @Input() set reportDetails(activityData: any) {
        this._activityID = activityData;
    };

    reportData: ReportJobDetails = new ReportJobDetails();   //holi
    _activityID: any;
    private options: any = [];
    private reportFilters: any = [];
    private reports: any = [];
    public reportsFiltered: any = []; // Observable<any[]>;
    private subReports: any = [];
    private subReportsInitial: any = [];
    private subReportsAll: any = [];
    private subReportsFiltered: any = [];
    private subReportsDB: any[];
    private filteredCollectionID: any;
    private filteredReportID: any;
    public selectedSubReportsList: any[];
    public selectedSubReports: any[];
    private isCollectionID: boolean = false;
    private initCollectionID: any;
    private initReportID: any;
    private optionId: any;

    private collectionReportsList: any;

    private selectedReport: any;
    
    private showReports: boolean = false;
    private showSubReportsGrid: boolean = false;
    public showSubReportsForm: boolean = false;

    constructor(private _insaChronosService: InsaCronService, private _localize: LocalizeService) { }



    ngOnInit() {
        this._insaChronosService.getOptions().subscribe((data: any) => {
            this.options = data;
            this.IsEditReportJobDetails();
        });
    }

    IsEditReportJobDetails(){
        if (this._activityID !== undefined && this._activityID !== null) {
            this._insaChronosService.getReportDetailsbyID(this._activityID).subscribe((a: any) => { 
                this.reportData = a; 
                let initOptionID = this.reportData.OptionID;
                this.optionId = this.reportData.OptionID;
                this.options.forEach(opt => {
                    if (opt.OptionID == initOptionID) {
                        this.initCollectionID = opt.CollectionID;
                        this.initReportID = opt.ReportID;
                    }
                });
                this.OnChangeCollection();
            });
            
        }
    }


    OnChangeCollection() {
        let filOpt = this.reportData.OptionID;
        this.optionId = this.reportData.OptionID;
        this._insaChronosService.getReportFilters(this.optionId).subscribe((rF: any) => this.reportFilters = rF)
        this.options.forEach(opt => {
            if (opt.OptionID == filOpt) {
                this.filteredCollectionID = opt.CollectionID;
                this.filteredReportID = opt.ReportID;
                console.log(this.filteredReportID);
                
                this.GetReports(this.filteredReportID, this.filteredCollectionID);
            }
        });
        
        if(this.filteredCollectionID != null || this.filteredCollectionID != undefined){
            this.showSubReportsGrid = false;
            this.showReports = true;
        } 
        else {
            // this.showSubReportsForm = true;
            this.selectedReport = this.filteredReportID;
            this.showReports = false;
            this.showSubReportsGrid = true;

        }
    }

    GetReports(filteredReportID, filteredCollectionID) {
        console.log("reportID --> ", filteredReportID, "; collectionID --> ", filteredCollectionID);
        if (filteredCollectionID != null || filteredCollectionID != undefined) {
            this.isCollectionID = true;
            
            // HOli
            //this._insaChronosService.getReportByCollId(filteredCollectionID).subscribe((fr: any) => {
            this._insaChronosService.getReportByCollId(filteredCollectionID, this.isCollectionID, this.initReportID, this.initCollectionID, this._activityID).subscribe((fr: any) => {
                this.collectionReportsList = fr;
                this.reportsFiltered = this.collectionReportsList.ReportList;
                this.subReportsInitial = this.collectionReportsList.SubReportList;
                if(this._activityID == undefined || this._activityID == null) this.RefreshReportList(this.reportsFiltered);
                
                //this.GetSubReports(filteredCollectionID, this.isCollectionID);

                if (this._activityID != undefined) {
                    this.SetEditReportList();
                    this.SetSubReport(this.subReportsInitial);
                }
                else this.SetSubReport(this.subReportsInitial);
            })
        }
        else {
            this.isCollectionID = false;
            // Holi 
            this._insaChronosService.getSubReportbyId(filteredReportID, this.isCollectionID,this.initReportID,this.initCollectionID, this._activityID).subscribe((sr: any) => {
                this.subReportsInitial = sr;
                if (this._activityID != undefined) {
                        this.SetEditReportList();
                        this.SetSubReport(this.subReportsInitial);
                }
                else this.SetSubReport(this.subReportsInitial);
            });
        }
    }

    RefreshReportList(reports: any[]) {
        if(this._activityID != undefined || this._activityID != null){
            this.InitKendoReportGrid(this.createReportsGridColumnDefs(), reports);
        } else this.InitKendoReportGrid(this.createReportsGridColumnDefs(), reports);
    }

    // Holi
    /*GetSubReports(filterID, isCollId) {
        this._insaChronosService.getSubReportbyId(filterID, isCollId,this.initReportID,this.initCollectionID, this._activityID).subscribe((sr: any) => {
            this.subReportsInitial = sr;
            if (this._activityID != undefined) {
                    this.SetEditReportList();
                    this.SetSubReport(this.subReportsInitial);
            }
            else this.SetSubReport(this.subReportsInitial);
        });

       // console.log("getsubreports subreports --> ", this.selectedSubReports);
    }*/

    SetEditReportList(){
        var i = 0;
        /*this.reportsFiltered.forEach( r => { 
            this.subReportsInitial.forEach( sri => {
                if(sri.ReportID == r.ReportID){
                    this.subReportsDB.forEach(srdb => {
                        if(srdb.ReportSubID == sri.ReportSubID){
                            i++
                        }
                    })
                }
                
            });
            console.log("initial report i --> ", i);
            if(i > 0) r.Show = true;
            else r.Show = false; 
        });*/

        this.RefreshReportList(this.reportsFiltered);
    }
    
    SetSubReport(subRepInit) {
        this.subReportsAll = subRepInit;

        this.selectedSubReports = this.subReportsAll.filter((sbl: any) => sbl.ReportPrint == 1).map(function (item) {
            let newData: Object = { text: item.ReportID, value: item.ReportSubID, };
            return newData;
        });



        console.log("setsubreport --> ", this.selectedSubReports)

        if(this.filteredReportID != undefined || this.filteredReportID != null){
            this.InitKendoSubReportGrid(this.createSubReportsGridColumnDefs(), this.subReportsAll);
        } 
        else {
            //this.showSubReportsForm = true;
            console.log("issub --> ", this.showSubReportsForm);
            this.selectedReport = this.filteredReportID;
            if(this.selectedReport){
                this.showSubReportsForm = true;
                console.log(this.showSubReportsForm);
            }
        }
    }

    private createReportsGridColumnDefs() {

        let reportListColumnDefs = new Array<ChronosJobListColumnDef>();

        reportListColumnDefs.push(new ChronosReportListColumnDef("ReportID", "ReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        reportListColumnDefs.push(new ChronosReportListColumnDef("Show", "Status", false, "<input name='Show' type='checkbox' data-bind='checked: Show' #= Show ? checked='checked' : '' #/>")) 
        reportListColumnDefs.push(new ChronosReportListColumnDef("ReportName", this._localize.getLocalizedResource('Res1701'), false, '#: (ReportName!==null)? ReportName : ""#')); //, '#:(JobID!==null) ? JobID : "" #'

        return reportListColumnDefs;
    }


    private getReportFromRow(e) {
        e.preventDefault();

        let reportList: kendo.ui.Grid = $("#ChronosReportList").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;

        switch (actionValue) {
            case "subReportBtn": {
                console.log("subReportBtn");
                this.selectedReport = reportList.dataItem(tr);
                this.showSubReportsForm = true;
                break;
            }
            default: {
                console.log("Invalid choice");
                break;
            }
        }
    }

    private InitKendoReportGrid(columnDefs, reportGridData) {

        let reportDataSourceOptions: kendo.data.DataSourceOptions = {};
        reportDataSourceOptions.data = reportGridData;
        reportDataSourceOptions.schema = {
            model: {
                ReportID: { type: "number" },
                fields: {
                    Show: { type: "boolean" },
                    ReportName: { type: "string", editable: false }

                }
            }
        };


        let reportDataSource: kendo.data.DataSource = new kendo.data.DataSource(reportDataSourceOptions);
        columnDefs.push({
            width: 20,
            command: [
                {
                    name: "subReportBtn",
                    className: 'k-icon k-i-folder-add',
                    title: "SubReports",
                    //text: 'POST ACTIONS',
                    click: this.getReportFromRow.bind(this)
                }
            ],
        });


        let reportGrid: kendo.ui.Grid = $("#ChronosReportList").data("kendoGrid");

        if (reportGrid == undefined) {
            let reportGridOptions: kendo.ui.GridOptions = {};
            reportGridOptions.dataSource = reportDataSource;
            reportGridOptions.filterable = false;
            reportGridOptions.sortable = false;
            reportGridOptions.selectable = false;
            reportGridOptions.reorderable = false;
            reportGridOptions.scrollable = false;
            reportGridOptions.noRecords = { template: SharedMethodsModule.noDataTemplate() };
            reportGridOptions.groupable = false;
            reportGridOptions.pageable = false;
            reportGridOptions.resizable = false;
            reportGridOptions.dataBound = function () {
                this.expandRow(this.tbody.find("tr.k-master-row").first());
            }
            reportGridOptions.columns = columnDefs;
            reportGridOptions.dataBound = customGroupHeader.KendoGridDataBound;

            reportGridOptions.editable = true;

            $("#ChronosReportList").kendoGrid(reportGridOptions);
            reportGrid = $("#ChronosReportList").data("kendoGrid");
                

            if(reportGrid != undefined) reportGrid.saveChanges();
        }
        else {
            reportGrid.setDataSource(reportDataSource);
        }
    }


    private createSubReportsGridColumnDefs() {

        let subReportListColumnDefs = new Array<ChronosJobListColumnDef>();
        
        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportID", "ReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        subReportListColumnDefs.push(new ChronosReportListColumnDef("SubReportID", "SubReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        // subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportPrint", "Status", false, "<input name='ReportPrint' type='checkbox' data-bind='checked: ReportPrint' #= ReportPrint ? checked='checked' : '' #/>", 100)) 
        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportPrint", "Status", false, "<input name='ReportPrint' type='checkbox' (change)='setSelectadRow()' data-bind='checked: ReportPrint' #= ReportPrint ? checked='checked' : '' #/>", 100)) 

        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportName", this._localize.getLocalizedResource('Res1203'), false, '#: (ReportName!==null)? ReportName : ""#')); //, '#:(JobID!==null) ? JobID : "" #'

        return subReportListColumnDefs;
    }

    private getSubReportFromRow(e) {
        e.preventDefault();

        let reportList: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;
    }

    private InitKendoSubReportGrid(columnDefs, subReportGridData) {

        let subReportDataSourceOptions: kendo.data.DataSourceOptions = {};
        subReportDataSourceOptions.data = subReportGridData;
        subReportDataSourceOptions.schema = {
            model: {
                SubReportID: {type: "number"},
                fields: {
                    ReportID: {type: "number" },
                    ReportPrint: {type: "boolean", selectable: true},
                    ReportName: {type:"string", editable: false}
                },
                
            },
        };

      let subReportDataSource: kendo.data.DataSource = new kendo.data.DataSource(subReportDataSourceOptions);    
      let subReportGrid: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");
      
      if (subReportGrid == undefined){
        let subReportGridOptions: kendo.ui.GridOptions = {};
        subReportGridOptions.dataSource = subReportDataSource;
        subReportGridOptions.filterable = false;
        //jobGridOptions.height = '100%';
        subReportGridOptions.sortable = false;
        //subReportGridOptions.selectable = false;
        subReportGridOptions.reorderable = false;
        subReportGridOptions.scrollable = false;
        subReportGridOptions.noRecords = {template: SharedMethodsModule.noDataTemplate()};
        //subReportGridOptions.selectable = "multiple, row";
        
        subReportGridOptions.pageable = false;
        subReportGridOptions.resizable = false;
        subReportGridOptions.editable = true;

        subReportGridOptions.columns = columnDefs;

        subReportGridOptions.dataBound = customGroupHeader.KendoGridDataBound;

        $("#ChronosSubReportList").kendoGrid(subReportGridOptions);
        subReportGrid = $("#ChronosSubReportList").data("kendoGrid");

        
        if(subReportGrid != undefined) subReportGrid.saveChanges();
    }
      else {
        subReportGrid.setDataSource(subReportDataSource);
      }  

      
    }

    GetNewSubReports(newSubReportList) {
        var i = 0;
        this.subReportsInitial = newSubReportList;

        this.reportsFiltered.forEach(r => {
            if (r.ReportID == this.selectedReport.ReportID) {
                newSubReportList.forEach(nsl => {
                    if (nsl.ReportID == r.ReportID && nsl.ReportPrint == 1) {
                        i++;
                    }
                });
                if (i > 0) r.Show = true;
                else r.Show = false;
            }
        });

        //this.RefreshReportList(this.reportsFiltered);

        this.InitKendoReportGrid(this.createReportsGridColumnDefs(), this.reportsFiltered);

        this.SetSubReport(newSubReportList);
        //this.selectedSubReports = newSubReportList.filter((sbl: any) => sbl.ReportPrint == true).map(sbl => sbl.ReportSubID);

    }


    ReportListChange() {
        console.log("ReportChange triggered");

        let changedReportListGrid: kendo.ui.Grid = $("#ChronosReportList").data("kendoGrid");
        let changedReportList = changedReportListGrid.dataSource.data().toJSON();



        changedReportList.forEach(chr => {
            this.reportsFiltered.forEach(rf => {
                if(rf.ReportID == chr.ReportID){
                  if(rf.Show != chr.Show){
                    if (chr.Show == false) {
                        this.subReportsInitial.forEach(ssr => {
                            if (chr.ReportID == ssr.ReportID) {
                                ssr.ReportPrint = 0;
                            }
                        })
                    }else if(chr.Show == true){
                        this.subReportsInitial.forEach(ssr => {
                            if (chr.ReportID == ssr.ReportID) {
                                ssr.ReportPrint = 1;
                            }
                        })
                    }
                }
            }
            });


            // Holi - old way
            // if (chr.Show == false) {
            //     this.subReportsInitial.forEach(ssr => {
            //         if (chr.ReportID == ssr.ReportID) {
            //             ssr.ReportPrint = 0;
            //         }
            //     })
            // }
        })

        this.SetSubReport(this.subReportsInitial);

        this.reportsFiltered = changedReportList;

        console.log("initial reportsList - reportsFiltered --> ", this.reportsFiltered)

        //this.selectedSubReports = this.subReportsInitial.filter((sbl: any) => sbl.ReportPrint == true).map(sbl => sbl.ReportSubID);

        //console.log("reportlistchange subreports --> ", this.selectedSubReports);

    }
    
    SubReportListChange(){
        let newSubRepListKendo: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");
        let newSubRepList = newSubRepListKendo.dataSource.data().toJSON();
        
        this.SetSubReport(newSubRepList);
        
        this.selectedSubReports = newSubRepList.filter((sbl: any) => sbl.ReportPrint == 1).map(sbl => sbl.ReportSubID);
        
        // console.log("newSubRepList --> ", newSubRepList);
        
        // console.log("selected new subreports --> ", this.selectedSubReports);
    }
    
    CloseSubReports(closeSubReports: boolean) {
        this.showSubReportsForm = closeSubReports;
    }

    hideModal() {
        this.showSubReportsForm = false;
    }


}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/report-job-details/edit-report-details.component.ts